import { AfterViewInit, Component, ElementRef, Input, NgZone, OnChanges, OnDestroy, ViewChild } from '@angular/core';
import { carregarMonaco } from './monaco-loader';

@Component({
  selector: 'habil-editor-diff',
  template: `<div #host class="editor-diff" [style.height]="altura"></div>`,
  styles: [
    `
      .editor-diff {
        width: 100%;
        border: 1px solid #dee2e6;
        border-radius: 6px;
        overflow: hidden;
      }
    `,
  ],
})
export class EditorDiffComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() original = '';
  @Input() modificado = '';
  @Input() linguagem = 'sql';
  @Input() altura = '420px';

  @ViewChild('host', { static: true }) host: ElementRef<HTMLDivElement>;

  private editor: any;
  private modelos: any[] = [];

  constructor(private zone: NgZone) {}

  ngAfterViewInit(): void {
    carregarMonaco().then((monaco) => {
      this.zone.runOutsideAngular(() => {
        this.editor = monaco.editor.createDiffEditor(this.host.nativeElement, {
          readOnly: true,
          automaticLayout: true,
          renderSideBySide: true,
          minimap: { enabled: false },
          fontSize: 13,
        });
        this.atualizar(monaco);
      });
    });
  }

  ngOnChanges(): void {
    const monaco = (window as any).monaco;
    if (this.editor && monaco) {
      this.atualizar(monaco);
    }
  }

  ngOnDestroy(): void {
    this.editor?.dispose();
    this.modelos.forEach((m) => m.dispose());
  }

  private atualizar(monaco: any): void {
    const anteriores = this.modelos;
    const original = monaco.editor.createModel(this.original || '', this.linguagem);
    const modificado = monaco.editor.createModel(this.modificado || '', this.linguagem);
    this.editor.setModel({ original, modified: modificado });
    this.modelos = [original, modificado];
    anteriores.forEach((m) => m.dispose());
  }
}
